if (!customElements.get("heala-trending-slider")) {
  class HealaTrendingSlider extends HTMLElement {
    constructor() {
      super();
      this.slider = null;
    }

    connectedCallback() {
      this.sliderContainer = this.querySelector("[data-trending-slider]");
      if (!this.sliderContainer) return;

      if (window.MinimogLibs && MinimogLibs.Swiper) {
        this.initSlider();
      } else {
        document.addEventListener("page:loaded", () => this.initSlider(), { once: true });
      }
    }

    disconnectedCallback() {
      this.destroySlider();
    }

    initSlider() {
      if (!this.sliderContainer || typeof MinimogLibs === "undefined" || !MinimogLibs.Swiper) return;
      if (this.slider) this.destroySlider();

      const slideCount = this.sliderContainer.querySelectorAll(".swiper-slide").length;
      if (!slideCount) return;

      const items = parseInt(this.dataset.items, 10) || 3;
      const gap = parseInt(this.dataset.gap, 10) || 20;
      const gapMobile = parseInt(this.dataset.gapMobile, 10) || 16;
      const showNavigation = this.dataset.showNavigation === "true";
      const showPagination = this.dataset.showPagination === "true";
      const autoplay = this.dataset.autoplay === "true";
      const timeout = parseInt(this.dataset.timeout, 10) || 4000;
      const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      const desktopItems = Math.min(items, slideCount);
      const tabletItems = Math.min(Math.max(2, Math.min(items, 3)), slideCount);
      const mobileItems = slideCount > 1 ? 1.15 : 1;
      const canLoop = slideCount > Math.ceil(desktopItems);

      const prevButton = this.querySelector(".m-slider-controls__button-prev");
      const nextButton = this.querySelector(".m-slider-controls__button-next");
      const paginationEl = this.querySelector(".swiper-pagination");
      const controls = this.querySelector(".m-slider-controls");

      this.slider = new MinimogLibs.Swiper(this.sliderContainer, {
        slidesPerView: mobileItems,
        slidesPerGroup: 1,
        spaceBetween: gapMobile,
        speed: reduceMotion ? 0 : 550,
        watchOverflow: true,
        watchSlidesProgress: true,
        loop: canLoop,
        threshold: 2,
        autoplay:
          autoplay && !reduceMotion && slideCount > 1
            ? {
                delay: timeout,
                disableOnInteraction: false,
                pauseOnMouseEnter: true,
              }
            : false,
        pagination:
          showPagination && paginationEl
            ? {
                el: paginationEl,
                clickable: true,
              }
            : false,
        navigation:
          showNavigation && prevButton && nextButton
            ? {
                prevEl: prevButton,
                nextEl: nextButton,
              }
            : false,
        a11y: {
          enabled: true,
          prevSlideMessage: "Previous slide",
          nextSlideMessage: "Next slide",
        },
        breakpoints: {
          768: {
            slidesPerView: tabletItems,
            spaceBetween: gap,
          },
          1024: {
            slidesPerView: desktopItems,
            spaceBetween: gap,
          },
        },
        on: {
          init: (swiper) => {
            this.toggleControls(controls, swiper);
          },
          breakpoint: (swiper) => {
            this.toggleControls(controls, swiper);
          },
        },
      });
    }

    toggleControls(controls, swiper) {
      if (!controls || !swiper) return;
      const isLocked = Boolean(swiper.isLocked);
      controls.classList.toggle("m:hidden", isLocked);
      swiper.allowTouchMove = !isLocked;
    }

    destroySlider() {
      if (this.slider && typeof this.slider.destroy === "function") {
        this.slider.destroy(true, true);
      }
      this.slider = null;
    }
  }

  customElements.define("heala-trending-slider", HealaTrendingSlider);
}
